const addCampaigns = {
  products: 'Productos',
  services: 'Servicios',
  pickAvaialbleCampaignTypes: 'Elija uno de los tipos de campaña disponibles',
  notes: 'Notes',
  pleaseDontChangeYourAppsIcon: 'Por favor, no cambie el ícono, el nombre o el nombre del editor de su aplicación mientras ejecuta una campaña. Nuestros usuarios buscarán su aplicación usando palabras clave y la única forma de encontrarla es mirando el icono y comparando el nombre de la aplicación.',
  whatIsAdvertisingCpiCampign: 'Qué es la campaña publicitaria de CPI?',
  cpi: 'CPI (cost-per-install) campaña - es una herramienta utilizada para atraer usuarios a su aplicación. Estos usuarios no están motivados con gemas o monedas como aquellos que instalan su aplicación cuando solicita instalaciones de palabras clave. Estos usuarios instalarán su aplicación solo si les gusta. Eso significa que atraerá a personas que generarán actividad e ingresos en la aplicación para usted.',
  keyword: 'Palabra clave',
  install: 'Instalar en pc',
  direct: 'Directo',
  instalaciones: 'Instalaciones',
  guaranteed: 'Garantizado',
  reviews: 'Reseñas',
  impressions: 'Impresiones',
  smart: 'Inteligente',
  campaign: 'Campaña',
  addCampaigns: 'Agregar campañas',
  addCampaign: 'Añadir campaña',
  advertising: 'Publicidad',
  summary: 'Resumen',
  product: 'Producto',
  keywordInstalls: 'Instalaciones de palabras clave',
  installsByKeywordsForYourApplication: 'Instalaciones por palabras clave para su aplicación en la región de destino',
  installsByDirectLink: 'Instalación mediante enlace directo a la aplicación en la región seleccionada',
  reviewsForYourApplication: 'Reseñas de su aplicación en la región seleccionada con garantía de 3 semanas para recarga y reembolso',
  installsGeneratedByAppsYourApplication: 'Instalaciones generadas por anuncios de tu aplicación en las regiones seleccionadas',
  cpiShort: 'Una campaña de CPI (costo por instalación) es una herramienta que se utiliza para atraer usuarios a tu aplicación',
  advertisingCpiCampaign: 'Рекламна кампанія CPI',
  application: 'Aplicación',
  targetCountry: 'País de destino',
  daysInCampaign: 'Días en campaña',
  finishAt: 'terminar en',
  campaignOrders: 'Pedidos de campaña',
  directInstalls: 'Instalaciones directas',
  rates: 'Tarifas',
  total: 'Total',
  day: 'Día',
  days: 'días',
  fixedPartner: 'Socio fijo',
  description: 'Descripción',
  saveDraft: 'Guardar borrador',
  draft: 'Borrador',
  delay: 'Retrasar',
  startCampaign: 'Iniciar campaña.',
  startNow: 'Crear',
  iAgreeTo: 'estoy de acuerdo con',
  terms: 'términos',
  ofUse: 'de uso',
  textSuccessfully: 'La campaña fue creada con éxito',
  textSuccessfullyDraft: 'Se creó un nuevo borrador de campaña #{id}',
  textErrorCountReviews: 'El número mínimo de instalaciones debe ser {minInstalls} * {days}. Por favor, añada más reseñas.',
  refundPolicyForRatesAndReviews: 'Política de reembolso para tarifas y reseñas',
  almostAllRatesAndReviewsAreGettingDeleted: '¡Advertencia! Casi todas las tarifas y reseñas están siendo eliminadas por cualquier tienda de aplicaciones, NO reembolsaremos dinero por tarifas y reseñas. Usélos bajo su propio riesgo',
  allRatesAndReviewsWillAppearOnMarket: 'Todas las tarifas y reseñas aparecerán en la página de mercado de su aplicación en 2-3 horas después de que se complete la campaña. Después de 1 o 2 días, la mayoría de las tarifas y reseñas ordenadas en esta sección se eliminarán y depende en gran medida del tipo de aplicación, su tráfico orgánico y las tarifas diarias habituales aumentan, por lo que, al continuar, acepta correr este riesgo.',
  ifYouNeedReviewsAndRates: 'Si necesita reseñas y tarifas para permanecer en la página de la aplicación, además de obtenerlas con la garantía de devolución del dinero o volver a publicarlas durante las 3 semanas posteriores a la finalización del pedido, vaya a la campaña Agregar reseñas garantizadas.',
  evenIfItIsOkay: 'Incluso si está bien para usted que se eliminen las tarifas y reseñas ordenadas en esta sección, no pida toneladas de ellas. El comportamiento de las tarifas debe verse como un flujo de usuarios real, proporcional al tráfico orgánico de su aplicación en el país seleccionado y similar a su número actual de tarifas.',
  iveReadAndAreeToThe: 'He leído y acepto las',
  chargebackAndRefundPolicy: 'Política de devolución de cargo y reembolso',
  deleteAllKeywords: 'Eliminar todas las palabras clave',
  minimumOrderInstallsIs: 'Número mínimo de instalaciones para un pedido',
  keywordInstall: {
    keywordInstallAddKeywordsBody: {
      keywords: 'Palabras clave',
      advancedMode: 'Modo avanzado',
      dayOne: 'día 1',
      addKeyword: 'Agregar palabra clave'
    },
    keywordInstallKeywordsTable: {
      noKeywordsFound: 'No se encontraron palabras clave',
      selectKeyword: 'Seleccionar palabra clave',
      addKeywordInstalls: 'Agregar instalaciones de palabras clave',
      installsDistribution: 'Instala Distribución',
      increase: 'Aumentar',
      parabolic: 'Parabólico',
      equal: 'Igual',
      days: 'Días'
    },
    directInstallTable: {
      addDirectInstalls: 'Agregar instalaciones directas',
      days: 'Días',
      packageOrDirectInstalls: 'Paquete o instalaciones directas',
      delete: 'Borrar'
    },
    ratesAndReviewsKeywordInstallBody: {
      ratesAndReviews: 'Tarifas y opiniones',
      addRatesAndReviewsToCampaign: 'Agregar tarifas y reseñas a la campaña',
      days: 'Días',
      rates: 'Tarifas',
      delete: 'Borrar',
      reviews: 'Reseñas',
      importReviews: 'Importar reseñas',
      errorCheckedTerms: 'Debe aceptar los términos de uso antes de solicitar tarifas o reseñas.'
    },
    promotionRuleKeywordInstallBody: {
      promotionRule: 'Regla de promoción',
      dontPromoteKeywordsWhenTheyReachRank: 'No promocione las palabras clave cuando alcanzan el rango',
      installsDeliveryType: 'Tipo de entrega de instalaciones',
      spreadInstallsForTwentyFourHours: 'Propaga las instalaciones durante 24 horas',
      allInstallsAtOnce: 'Todas las instalaciones a la vez',
      deeplinkTitle: 'Enlace profundo',
      deeplink: 'El enlace profundo se ejecuta después de la instalación de la aplicación, por ejemplo, run?source=keyapp, ',
      deeplinkIos: 'Lee más en nuestro blog'
    },
    addMyReviewsModal: {
      pleaseWait: 'Procesando, por favor espere...',
      addMyReviews: 'Agregar mis Reseñas',
      added: 'Agregado',
      newReview: 'Agregar nueva revisión',
      addManyRandomReview: 'Agregar 5 reseñas aleatorias',
      deleteAll: 'Eliminar todos',
      saveReview: 'Guardar reseña',
      deleteReview: 'Eliminar reseña',
      editReview: 'Editar reseña',
      reviews: 'reseñas',
      youHaveNoAddedReviewsYet: 'Aún no has añadido reseñas',
      add: 'Agregar',
      errorLength: 'Número mínimo de respuestas requeridas: {min}.',
      titleText: 'Agregar nuevo título de revisión',
      bodyText: 'Agregar nuevo texto de revisión'
    },
    descriptionKeywordInstallBody: {
      description: 'Descripción',
      leaveAnyNotesForYourcampaign: 'Deje notas para su campaña (solo en inglés, 1000 símbolos como máximo)'
    }
  },
  impressionsSection: {
    title: 'Impresiones',
    conversionRate: 'Tasa de conversión (CVR)',
    impressionsNumberTooltip: 'CVR: cuanto menor sea el porcentaje, más impresiones se agregarán',
    helpText1: 'Las impresiones ayudan a mantener una tasa de conversión natural (CVR) al agregar vistas adicionales de su aplicación en los resultados de búsqueda.',
    helpText2: 'Utilice el control deslizante para elegir su CVR objetivo: cuanto menor sea el porcentaje, más impresiones se agregarán.',
    helpText3: 'Las impresiones se distribuirán uniformemente entre todas las palabras clave y días de campaña.'
  },
  guaranteedReviews: {
    reviewGuaranteedReviewsBody: {
      mustBeAtLeast: 'Debe ser al menos',
      guaranteedReviews: 'Reseñas garantizadas',
      addGuaranreedReviewsToYourApplication: 'Agregue revisiones garantizadas a su aplicación',
      myCustom: 'mi costumbre',
      reviews: 'reseñas',
      writeReviews: 'Escribir reseñas',
      forMe: 'for mepara mi',
      improveYourRatesAndAppsReputation: 'Mejora tus tarifas y la reputación de tus aplicaciones con nuestras reseñas. Obtenga una garantía de 3 semanas para cualquier pedido.',
      campaignDetails: 'Detalles de la campaña',
      days: 'Días',
      _reviews: 'Reseñas',
      importReviews: 'Importar reseñas',
      delete: 'Borrar',
      authorGender: 'Género del autor',
      male: 'Masculino',
      female: 'Femenino',
      both: 'Ambos',
      pickPreferredGenderOfAccount: 'Elija un género preferido de cuenta que escribirá una reseña',
      reviewLanguage: 'Revisar idioma',
      pickPreferredLanguageForReviews: 'Elija un idioma preferido para las revisiones, o se utilizará el idioma predeterminado de un país elegido',
      description: 'Descripción',
      leaveAnyNotesForYourOrder: 'Deje notas para su pedido (solo en inglés, 1000 símbolos), p. palabras clave preferidas, frases, etc.',
      notes: 'notas',
      thisIsGuaranteedReviewsOrder: 'Este es un pedido de reseñas garantizadas, lo que significa que si solicita 100 reseñas, le garantizamos que no menos de 90 de ellas permanecerán en la página de su aplicación durante un mínimo de 3 semanas; de lo contrario, volveremos a publicar las reseñas que falten. Además, su pedido puede estar en estado de MODERACIÓN durante 12-48 horas hasta que verifiquemos todas las revisiones.'
    }
  },
  startModalCpi: {
    customer: 'Cliente'
  },
  advertisingCampaign: {
    advertisingCampaignTab: {
      back: 'atrás',
      startCampaign: 'Iniciar campaña',
      pleaseWait: 'Espere por favor...',
      next: 'Próximo'
    },
    advertisingCampaignStep1: {
      addTargetCountriesForAppPromotion: 'Agregar países de destino para la promoción de la aplicación',
      usuallyWeRecommendToStartCpiAampaignsInSuchCases: 'Por lo general, recomendamos iniciar campañas de CPI en tales casos.',
      youDontHave: 'no tienes',
      organicTrafficOnYourApp: 'tráfico orgánico en su aplicación, pero desea iniciar campañas de promoción de palabras clave. Cuando ordena instalaciones de palabras clave e instalaciones de CPI al mismo tiempo, aumenta la clasificación de las palabras clave de su aplicación mucho más rápido',
      youHave: 'Tú tienes',
      newAppAndYouWantToGetKeywordsIndexationFaster: 'una nueva aplicación y desea obtener la indexación de palabras clave más rápido',
      newAppAndYouWantToGetYourMainPageInstallsNumberHigher: 'una nueva aplicación y desea aumentar el número de instalaciones de su página principal',
      toGetBetterCategoryRankings: 'para obtener mejores clasificaciones de categoría',
      youEarnMore: 'ganas mas',
      fromEachInstallThenYouPayForIt: 'de cada instalación luego pagas por ella',
      toAttractUsersFromSpecifiedRegion: 'para atraer usuarios de una región específica',
      cryptocurrenciesBinaryOptionsPersonalLoansAppsAreForbidden: 'Se prohíben las criptomonedas, las opciones binarias, los préstamos personales y aplicaciones similares.',
      youWant: 'Usted quiere',
      pleaseNote: 'tenga en cuenta'
    },
    advertisingCampaignStep2: {
      selectPromotionCountries: 'Seleccionar países de promoción',
      addTargetCountriesForAppPromotion: 'Agregar países de destino para la promoción de la aplicación',
      filterByCpi: 'Filtrado por CPI',
      filterByGeo: 'Filtrado por GEO',
      filterByLanguage: 'Filtrado por language',
      highCpi: 'Alto CPI',
      mediumCpi: 'Medio CPI',
      lowCpi: 'Bajo CPI',
      europe: 'Europa',
      asia: 'Asia',
      africa: 'Áfrico',
      latinAmerica: 'America latina',
      worldwide: 'En todo el mundo',
      english: 'Inglés',
      spanish: 'Español',
      russian: 'Ruso',
      targetedCountries: 'Países objetivo'
    },
    advertisingCampaignStep3: {
      campaignBudget: 'Presupuesto Campaña',
      defineDailyBudget: 'Defina el presupuesto diario, el total de días y el CPI objetivo',
      dailyBudget: 'Presupuesto diario',
      targetCpi: 'Objetivo CPI',
      daysInCampaign: 'Días en campaña',
      unlimited: 'Ilimitado',
      days: 'días',
      daysInCampaignMustBeAtLeast: 'El número de días en la campaña debe ser al menos',
    },
    advertisingCampaignStep4: {
      headlines: 'Titulares',
      addHeadlinesAndDescriptionsForAds: 'Agregue títulos y descripciones para los anuncios',
      headlineOne: 'Titular #1',
      weUseHeadlinesAndDescriptionsToAdvertiseYourApp: 'Usamos títulos y descripciones para publicitar su aplicación. Los títulos y descripciones atractivos pueden ayudarlo a obtener un mejor CTR (más clics de las vistas), por lo que su CPI promedio será más bajo.',
      generate: 'Generar',
      headlineTwo: 'Titular #2',
      misleadingDescriptions: 'Las descripciones engañosas pueden aumentar el CTR, pero los usuarios no instalarán su aplicación cuando consulten la página de su aplicación. Por lo tanto, obtendrá una tasa de conversión baja y su CPI aumentará.',
      description: 'Descripción',
      checkThatYourTextMakesSenseForUsers: 'Comprueba que tu texto tiene sentido para los usuarios. Es importante porque nuestros socios de redes publicitarias aplicarán un proceso de aprobación a sus anuncios. Si infringe algunas reglas, sus anuncios querrán pasar el proceso de aprobación.',
      headlineOneIsNotSet: 'El título n.° 1 no está definido',
      headlineOneIsTooShort: 'El título n.° 1 es demasiado corto. Longitud mínima:',
      headlineOneIsTooLong: 'El título n.° 1 es demasiado largo. Longitud máxima:',
      headlineTwoIsNotSet: 'El título n.° 2 no está definido',
      headlineTwoIsTooShort: 'El título n.° 2 es demasiado corto. Longitud mínima:',
      headlineTwoIsTooLong: 'El título n.° 2 es demasiado largo. Longitud máxima:',
      descriptionIsNotSet: 'La descripción no está definida',
      descriptionIsTooShort: 'La descripción es demasiado corta. Longitud mínima:',
      descriptionIsTooLong: 'La descripción es demasiado larga. Longitud máxima:',
      headlinesAndDescriptionsShouldBeUnique: 'Los títulos y las descripciones deben ser únicos',
    },
    advertisingCampaignStep5: {
      finish: '¡Listo!',
      summary: 'Resumen',
      confirmCampaignDetails: 'Confirmar detalles de la campaña',
      application: 'Solicitud',
      nameOfApplication: 'Nombre de la aplicación...',
      developer: 'Desarrollador',
      countries: 'Países',
      duration: 'Duración',
      targetCpi: 'Objetivo CPI',
      dailyBudget: 'Presupuesto diario',
      startCharge: 'Iniciar carga',
      toStartThisCampaign: 'Para iniciar esta campaña cargaremos tu saldo por 20 $. Necesitamos esta cantidad (en realidad, es el doble del presupuesto diario) como prepago para futuros gastos de campaña.',
      weWillChargeYourAccount: 'Cargaremos en su cuenta todos los días el monto que gastó en la promoción durante el día anterior. Si no tiene suficientes fondos en su saldo para cubrir los gastos del día anterior, utilizaremos su cargo de Inicio y pausará la campaña hasta que recargue su saldo y reanude manualmente la campaña.',
      refund: 'Reembolso',
      youMayCancelYourCampaign: 'Puede cancelar su campaña en cualquier momento, pero haremos un reembolso solo después de 24 horas después de la cancelación para detener la campaña en todas las redes publicitarias y obtener los gastos reales de la campaña. La misma regla se aplica para completar campañas. El monto del reembolso se calcula como la diferencia entre el precio de la campaña y los gastos de la campaña.',
      dailyCharge: 'Cargo diario'
    },
    advertisingCampaignAside: {
      letsStart: '¡Empecemos!',
      createNewCpiCampaign: 'crear nueva campaña de CPI',
      budget: 'Presupuesto',
      adjustBudget: 'ajustar presupuesto, CPI y duración',
      regions: 'Regiones',
      selectTargetedCountries: 'seleccionar países objetivo',
      headlines: 'Títulos',
      inputTextForAds: 'introducir texto para anuncios',
      finish: 'Finalizar',
      startYourNewCampaign: 'iniciar nueva campaña',
      selectCountries: 'Seleccionar países',
      detailsOfStepOneHere: 'detalles del paso 1 aquí',
      stepTwo: 'Paso 2',
      detailsOfStepTwoHere: 'detalles del paso 2 aquí',
      stepThree: 'Paso 3',
      detailsOfStepThreeHere: 'detalles del paso 3 aquí',
      stepFour: 'Paso 4',
      detailsOfStepFourHere: 'detalles del paso 4 aquí',
      stepFive: 'Paso 5',
      detailsOfStepFiveHere: 'detalles del paso 5 aquí'
    }
  },
  delayedModal: {
    delayedCampaign: 'Campaña retrasada',
    selectTheDate: 'Seleccione la fecha en la que desea iniciar su campaña',
    yourAccountWillBeDebited: 'Su cuenta será debitada el {date}',
    date: 'Fecha',
    time: 'Hora',
    dateOrTimeIsEmpty: 'La fecha u hora está vacía',
    pleaseChangeDateOrTime: 'Por favor, introduzca una fecha y hora con más de 5 minutos de retraso',
  },
  addCampaignsHeader: {
    keywordInstalls: 'Instalaciones de palabras clave',
    directInstalls: 'Instalaciones directas',
    guaranteedReviews: 'Reseñas garantizadas',
    advertisingCampaign: 'Campaña publicitaria'
  },
  addCampaignLoadingModal: {
    title: 'Se está creando la campaña...'
  }
};

export default addCampaigns;
